/** Conservative cross-browser canvas limits (Chrome/Firefox ~16384/side; Safari area ~268M px). */
export const MAX_CANVAS_DIMENSION = 16_384;
export const MAX_CANVAS_AREA = 268_435_456;
/** Floor so we never allocate a zero-size canvas. */
export const MIN_RENDER_SCALE = 0.25;

/**
 * Clamp pdf.js render scale so the resulting canvas stays within browser limits.
 * Layout zoom (wrapper width) is independent — callers may CSS-upscale when clamped.
 *
 * @param baseViewportWidth - from `page.getViewport({ scale: 1, rotation })`
 * @param baseViewportHeight - same; rotation already reflected in dimensions
 * @param desiredScale - typically `1.5 * zoom`
 */
export function clampPdfRenderScale(
  baseViewportWidth: number,
  baseViewportHeight: number,
  desiredScale: number,
): number {
  if (baseViewportWidth <= 0 || baseViewportHeight <= 0) {
    return MIN_RENDER_SCALE;
  }

  const maxByWidth = MAX_CANVAS_DIMENSION / baseViewportWidth;
  const maxByHeight = MAX_CANVAS_DIMENSION / baseViewportHeight;
  const maxByArea = Math.sqrt(
    MAX_CANVAS_AREA / (baseViewportWidth * baseViewportHeight),
  );
  const maxSafe = Math.min(maxByWidth, maxByHeight, maxByArea);

  return Math.max(MIN_RENDER_SCALE, Math.min(desiredScale, maxSafe));
}
